import React from 'react';

import { EnvironmentProvider } from '../../contexts/EnvironmentContext';
import TConfig from '../../types/TConfigurablePage';
import Section from './components/Section';
import HeaderImage from './components/HeaderImage';
import './configurablePageApp.scss';

type TProps = {
  appState: TConfig;
  environment: {
    staticBaseUrl: string;
    xsrfToken: string;
    baseUrl: string;
  };
};

const ConfigurablePageApp = ({ appState, environment }: TProps) => {
  const { header, sections } = appState;

  return (
    <EnvironmentProvider value={environment}>
      {!!header && <HeaderImage imageUrl={header.imageUrl} text={header.body?.title} />}
      <div className="configurablePage-contentRoot">
        {sections.map((section, i) => (
          <Section section={section} key={`configurable-page-section-${i}`} />
        ))}
      </div>
    </EnvironmentProvider>
  );
};
export default ConfigurablePageApp;
